import { render, staticRenderFns } from "./ErrorMessageCommentContainer.vue?vue&type=template&id=6b3e2363&scoped=true&"
import script from "./ErrorMessageCommentContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageCommentContainer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageCommentContainer.vue?vue&type=style&index=0&id=6b3e2363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e2363",
  null
  
)

export default component.exports